module.exports = __webpack_public_path__ + "static/media/18.0b6391f8.jpg";